/* "Arrives Sep 30 - Oct 2" on the product page and the homepage hero.
 *
 * Last-minute gift buyers used to meet the date only on the customizer's last
 * step: they designed a whole mug, learned it was too late, and left.
 *
 * The date is NEVER calculated here. It comes from window.Mugsley.arrival()
 * (embed v0.2.49+), the same call the customizer's last step uses, so the two
 * can't disagree. If the loader is missing, older than v0.2.49, or returns
 * nothing, this shows NO line at all - a blank or guessed date next to a buy
 * button is worse than no date.
 *
 * The line is inserted rather than written into Liquid on purpose: the product
 * page and homepage sections belong to other sessions, and the date needs
 * JavaScript anyway, so nothing of theirs has to be edited to carry it.
 */
(function () {
  var STEP = 150;
  var MAX_WAIT = 6000; /* the loader is deferred; give it time, then give up quietly */

  function buildLine(text) {
    var p = document.createElement('p');
    p.className = 'mug-arrival';
    p.setAttribute('data-mug-arrival', '');
    p.innerHTML =
      '<svg class="mug-arrival__icon" viewBox="0 0 24 24" aria-hidden="true" fill="none"' +
      ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="3" y="5" width="18" height="16" rx="3"/><path d="M8 3v4M16 3v4M3 10h18"/></svg>' +
      '<span></span>';
    /* textContent, never innerHTML: the string comes from another origin's script */
    p.querySelector('span').textContent = text;
    return p;
  }

  function insertAfter(node, line) {
    node.parentNode.insertBefore(line, node.nextSibling);
  }

  function place(dates) {
    if (document.querySelector('[data-mug-arrival]')) return;

    /* Product page: under the price, above the buy button. Scoped to the info
       column so the sticky bar's own price is never matched.

       Placed after the price's whole ROW, not after the price itself: that row
       is a nowrap flex line holding the price and the FREE SHIPPING badge, so a
       third item was squeezed into 113px and wrapped over three lines
       (2026-09-24). Below the row it gets the full column, reads as one line,
       and the badge sits above it. */
    var price = document.querySelector('.product__info-container .price');
    if (price) {
      var row = price.parentElement;
      var anchor = (row && !row.classList.contains('product__info-container')) ? row : price;
      insertAfter(anchor, buildLine('Ships in 1 business day · Arrives ' + dates));
      return;
    }

    /* Homepage hero: after the CTA's own price line, so the two read as a pair.
       The hero already says "Free standard shipping" one line up, so this says
       only "Arrives ..." - see the note to the operator (2026-09-24). */
    var actions = document.querySelector('.hero-actions');
    if (actions) {
      var anchor = (actions.parentNode && actions.parentNode.querySelector('.price-line')) || actions;
      insertAfter(anchor, buildLine('Arrives ' + dates));
    }
  }

  function boot() {
    var waited = 0;
    (function tick() {
      var M = window.Mugsley;
      if (M && typeof M.arrival === 'function') {
        var dates = '';
        try { dates = M.arrival() || ''; } catch (error) { dates = ''; }
        if (dates) place(dates);
        return; /* answered: show it or stay silent, but stop polling */
      }
      waited += STEP;
      if (waited < MAX_WAIT) setTimeout(tick, STEP);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
